
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.36 7.5A11.24 11.24 0 0012.78 0h-.04a11.2 11.2 0 00-9.66 16.9L.05 23.27a.5.5 0 00.67.67l6.37-3.03A11.24 11.24 0 0023.36 7.5zm-4.18 11.7c-3.38 2.72-8.12 3-11.8.72a.5.5 0 00-.48-.03l-5.34 2.54L4.1 17.1a.5.5 0 00-.03-.48 10.21 10.21 0 018.67-15.6h.04a10.24 10.24 0 016.4 18.2z"}}),_c('path',{attrs:{"d":"M14.39 17.16h-3.25a.5.5 0 000 1h3.25a.5.5 0 000-1zm.07-12.64a4.33 4.33 0 00-5.58 5.83 15.17 15.17 0 011.45 3.76c.09.47.48.8.94.8h3.01c.46 0 .85-.33.95-.78.2-1.07.64-2.24 1.27-3.5.3-.6.49-1.29.53-1.93a4.27 4.27 0 00-2.57-4.18zm1.14 5.66a15.22 15.22 0 00-1.35 3.73l-2.94.01c-.28-1.46-.91-2.75-1.53-4a3.32 3.32 0 01.61-3.73 3.26 3.26 0 015.64 2.44 4.18 4.18 0 01-.43 1.55zm-1.21 5.36h-3.25a.5.5 0 000 1h3.25a.5.5 0 000-1z"}})])
          )
        }
      }
    